import React, { useEffect, useState } from 'react';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Components
import Modal from 'react-modal';
// Services
import { sendUserSearchInformation } from '../../services/sendUserSearchInformation';
// Images
import PlayButtonImage from '../../Images/play-button.svg';
import PlaceholderImage from '../../Images/placeholder-image.png';
// Styles
import './CardVideo.css';
import FavoriteButton from '../FavoriteButton';
import { FavoriteCategory } from '../../Views/FavoriteDetail/types';
import {
	getFavoriteByUrl,
	handleDeleteFavorite,
} from '../FavoriteButton/utils';
// Slice
import { setLms } from '../../app/features/userSlice';
import { useNavigate } from 'react-router-dom';
import { useCookie } from '../../hooks/useCookie';
import UserIcon from '../../Images/user-icon.png';
import DownloadIconWhite from '../../Images/download-icon-white.png';
import DownloadIcon from '../../Images/download-icon.png';
import CloseIcon from '../../Images/close-btn.png';
import { generateCertificatePDF } from '../../Components/TutorialCertificate';
import ResponsiveTutorialIframe from '../ResponsiveTutorialIframe';

const isValidEmail = (email) => {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
};

const CardVideo = ({
	image,
	time,
	title,
	description,
	url,
	language,
	type = 'youtube',
	favoriteType = 'favorite', // favorite | detail
	favoriteCategory = FavoriteCategory.MEDIA,
	onDeleteFavorite,
	showFavoriteButton = true,
	isTutorial = false,
	userFullName = '',
}) => {
	const { setCookie } = useCookie('is_validating_identity');
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [favoriteStatus, setFavoriteStatus] = useState(false);
	const favorites = useSelector((state) => state.favorites.favorites);
	const { user_email, user_name, user_lastname } = useSelector(
		(state) => state.user
	);
	const { institutionCode, assignedLogin } = useSelector(
		(state) => state.institution
	);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [selectedVideoUrl, setSelectedVideoUrl] = useState('');
	const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
	const [certificateName, setCertificateName] = useState(() => {
		const parts = [];

		if (!isValidEmail(user_name)) parts.push(user_name);
		if (!isValidEmail(user_lastname)) parts.push(user_lastname);

		return parts.join(' ');
	});

	// Type youtube | vimeo | external | new_tab
	const getURL = (id, type) => {
		switch (type) {
			case 'youtube':
				return `https://www.youtube.com/embed/${id}`;
			case 'vimeo':
				return `https://player.vimeo.com/video/${id}`;
			case 'external':
				return url;

			default:
				return `https://www.youtube.com/embed/${id}`;
		}
	};

	const handleDownloadCertificate = () => {
		generateCertificatePDF(certificateName, new Date(), institutionCode);
	};

	const handleClicCard = (id, type) => {
		setSelectedVideoUrl(`${getURL(id, type)}`);
		setModalIsOpen(true);
		sendUserSearchInformation(
			title,
			'Google scholar',
			url,
			'Media',
			user_email,
			institutionCode
		);
	};

	// Obliga al estudiante a hacer login con canvas para obtener su nombre y apellido
	const handleVerifyMyIdentity = () => {
		const hasCanvaLogin = assignedLogin?.includes('canvas');
		if (hasCanvaLogin) {
			setCookie('true');
			dispatch(setLms('canvas'));
			navigate('/?verify_identity=true');
		}
	};

	// Manejador de modal (close)
	const closeModal = () => {
		setSelectedVideoUrl('');
		setModalIsOpen(false);
	};

	const closeModalCertificate = () => {
		setCertificateName('');
		setIsCertificateModalOpen(false);
	};

	useEffect(() => {
		const hasFavorite = getFavoriteByUrl(url, favorites);

		setFavoriteStatus(!!hasFavorite);
	}, [favorites, url]);
	return (
		<>
			<Modal
				isOpen={isCertificateModalOpen}
				onRequestClose={closeModalCertificate}
				contentLabel='Download Certificate'
				style={{
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						transform: 'translate(-50%, -50%)',
						maxWidth: '350px',
						maxHeight: '80%',
						padding: '1.5rem',
					},
					overlay: {
						zIndex: 1000,
					},
				}}
			>
				<button
					className='close-modal-certificate'
					onClick={closeModalCertificate}
				>
					<img src={CloseIcon} alt='close icon' />
				</button>
				<div className='cert-title-modal'>Download Certificate</div>

				<div className='cert-description-modal'>
					Please enter your first and last name to generate your personalized
					certificate.
				</div>

				<div className='cert-input-modal'>
					<input
						type='text'
						placeholder='Enter your full name'
						value={certificateName}
						onChange={(e) => setCertificateName(e.target.value)}
					/>
				</div>

				<div className='cert-btn-modal'>
					<button
						onClick={handleDownloadCertificate}
						className={`verify-identity-certificate-btn ${
							certificateName?.length > 2 ? '' : 'opacity-50'
						}`}
						disabled={certificateName?.length > 2 ? false : true}
					>
						Generate Certificate
						<img
							className='download-icon-certificate'
							src={DownloadIconWhite}
							alt='Download Icon'
						/>
					</button>
				</div>
			</Modal>

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				contentLabel='Video Modal'
				style={{
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						transform: 'translate(-50%, -50%)',
						maxWidth: type === 'external' ? 'calc(100vw - 3rem)' : '80%',
						maxHeight: type === 'external' ? 'calc(100vh - 6rem)' : '80%',
						width: 'initial',
						height: 'initial',
					},
				}}
			>
				{type !== 'external' && (
					<iframe
						className='videoModal'
						title='title video'
						src={selectedVideoUrl}
						controls
						allowFullScreen
					></iframe>
				)}

				{type === 'external' && (
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<ResponsiveTutorialIframe src={selectedVideoUrl} />

						<div style={{ paddingTop: '1rem' }}></div>
						{/* Cuando incluya canvas como login  */}
						{assignedLogin.includes('canvas') &&
							(isValidEmail(user_name) || isValidEmail(user_lastname)) && (
								<button
									onClick={handleVerifyMyIdentity}
									className='verify-identity-certificate-btn'
								>
									Verify Identity & Download Certificate{' '}
									<img src={UserIcon} alt='user icon' />
								</button>
							)}

						{/* Cuando incluya canvas como login, descargara sin mostrar modal  */}
						{isTutorial &&
							!isValidEmail(user_name) &&
							!isValidEmail(user_lastname) &&
							assignedLogin.includes('canvas') && (
								<button onClick={() => setIsCertificateModalOpen(true)}>
									Download Certificate{' '}
									<img
										className='download-icon-certificate'
										src={DownloadIcon}
										alt='Download Icon'
									/>
								</button>
							)}

						{/* Si no incluye canvas como login, muestra el modal para cambiar nombre */}
						{isTutorial && !assignedLogin.includes('canvas') && (
							<button onClick={() => setIsCertificateModalOpen(true)}>
								Download Certificate{' '}
								<img
									className='download-icon-certificate'
									src={DownloadIcon}
									alt='Download Icon'
								/>
							</button>
						)}
					</div>
				)}
			</Modal>

			<div
				className='card-video'
				// onClick={() => handleClicCard(url, type)}
				onClick={() =>
					type !== 'new_tab'
						? handleClicCard(url, type)
						: window.open(url, '_blank')
				}
				role='button'
				tabIndex='0'
			>
				<div className='thumbnail_image'>
					<div className='thumbnail_image__play-button'>
						<img src={PlayButtonImage} alt='play' className='button-svg' />
					</div>
					<div className='thumbnailContainer'>
						<img
							src={image ? image : PlaceholderImage}
							alt='thumbnail'
							className='thumbnail'
						/>
					</div>

					{time && <div className='thumbnail_time'>{time}</div>}
				</div>

				<div className='resource_content'>
					<div className='resource_content__top-content'>
						{title && <div className='resource_title'>{title}</div>}
						{showFavoriteButton && (
							<FavoriteButton
								isAbsolute={false}
								type={favoriteType}
								category={favoriteCategory}
								favoriteData={{
									description,
									favoriteCategory,
									language,
									time,
									title,
									type,
									url,
									image,
								}}
								isFavorite={favoriteStatus}
								onDeleteFavorite={() =>
									handleDeleteFavorite(
										url,
										favorites,
										favoriteType,
										user_email,
										dispatch,
										onDeleteFavorite
									)
								}
								// onDeleteFavorite={onDeleteFavorite}
								url={type === 'new_tab' ? url : getURL(url, type)}
							/>
						)}
					</div>

					{description && (
						<div className='resource_description'>{description}</div>
					)}
				</div>
			</div>
		</>
	);
};

export default CardVideo;
